import React from "react";
import { Link } from "react-router-dom";
import Button from "../../../components/Button";
import { FaCalendarTimes } from "react-icons/fa";

const NoTournaments = () => {
  return (
    <div className="flex flex-col max-w-xl w-11/12 bg-white mt-8 p-8 items-center rounded-xl shadow-xl border border-yellow-500">
      <FaCalendarTimes className="text-yellow-500 text-6xl mb-6" />

      <h2 className="text-2xl font-semibold text-center text-gray-900 mb-4">
        No Upcoming Tournaments
      </h2>
      <p className="text-center text-gray-700 mb-4">
        Check out the archive to see previous tournament results
      </p>

      <Link to={`/archive`}>
        <Button color="yellow" className="bg-yellow-500">
          Archive
        </Button>
      </Link>
    </div>
  );
};

export default NoTournaments;
